import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  darker: {
    color: theme.palette.darker,
  },

  default: {
    color: theme.palette.primary.main,
  },

  delete: {
    color: theme.palette.deleted,
  },

  disabled: {
    color: theme.palette.disabled,
  },

  failed: {
    color: theme.palette.failed,
  },
}));

const FontAwesomeIcon = ({
  variant = "default",
  disabled = false,
  icon,
  ...otherProps
}) => {
  const classes = useStyles();
  return (
    <Icon
      className={clsx({
        [classes.darker]: variant === "darker" && !disabled,
        [classes.default]: variant === "default" && !disabled,
        [classes.delete]: variant === "delete" && !disabled,
        [classes.failed]: variant === "failed" && !disabled,
        [classes.disabled]: disabled,
      })}
      icon={icon}
      {...otherProps}
    />
  );
};

export default FontAwesomeIcon;
